export default __webpack_public_path__ + "static/media/newExportIcon.9b2da77f.svg";